export const initialClass = {
  id: null,
  name: null,
  version: null,
  parentId: null,
  accountingId: null,
};
